// AA Damascus Knives — Scroll Reveal Animations
(function () {
  'use strict';

  var REVEAL_CLASS = 'aa-reveal';
  var VISIBLE_CLASS = 'is-visible';

  // Elements to animate on scroll
  var TARGETS = [
    '.shopify-section .section-header',
    '.shopify-section .section-header__title',
    '.collection-grid-item',
    '.grid-product',
    '.testimonials__item',
    '.text-and-image__text',
    '.text-and-image__image-wrapper',
    '.newsletter',
    '.featured-collection .grid-product',
  ].join(', ');

  function init() {
    var elements = document.querySelectorAll(TARGETS);
    if (!elements.length) return;

    // Skip hero — always visible
    var heroSection = document.querySelector('.slideshow');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add(VISIBLE_CLASS);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    elements.forEach(function (el, index) {
      // Don't animate elements inside the hero
      if (heroSection && heroSection.contains(el)) return;

      el.classList.add(REVEAL_CLASS);

      // Stagger siblings in grid layouts
      var parent = el.parentElement;
      if (parent) {
        var siblings = parent.querySelectorAll('.' + el.className.split(' ')[0]);
        var position = Array.prototype.indexOf.call(siblings, el);
        if (position > 0 && position <= 4) {
          el.classList.add('aa-reveal-delay-' + position);
        }
      }

      observer.observe(el);
    });

    // Mark section headers visible when section enters viewport
    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add(VISIBLE_CLASS);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.shopify-section').forEach(function (section) {
      if (heroSection && section === heroSection) return;
      sectionObserver.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
